import { useWeb3 } from '@/hooks/use-web3';
import { StateFilter } from '@/lib/filter/stakingPoolState';
import { reduceCheckAndPushKey, reducePoolStatus } from '@/lib/orderFunctions/reduce/pool';
import { promiseAllSettled } from '@/lib/Promise';
import { ResGetPoolDetailsCall, StatusGetPoolDetailsCall } from '@/types';
import { Fragment, useEffect, useRef, useState } from 'react';
import PoolCards from '../mui/PoolCards';
import { Box, Typography, useTheme } from '@mui/material';
import PoolsCard from './card/PoolsCard';
import CommonButton from './CommonButton';
export default function Pools() {
  const address = useRef<string>('');
  const { web3authCall } = useWeb3();
  const [lists, setLists] = useState<StatusGetPoolDetailsCall | null>(null);
  // theme
  const theme = useTheme();

  useEffect(() => {
    if (address.current) {
      return;
    }
    (async () => {
      if (web3authCall?.connected()) {
        const addr = await web3authCall.getAddress();
        address.current = addr;
      }
      const pools = await getAllPools();
      setAssetList(pools);
    })();
    return () => {};
  }, [web3authCall]);

  const getAllPools = async (): Promise<string[]> => {
    const re = await web3authCall?.getStakingCall().getAllPools();
    if (!re?.length) {
      return [];
    }
    return re;
  };
  const setAssetList = async (aPayload: string[]) => {
    const arrFactoryPoolDetails = []; // 스테이킹 정보
    const arrState = []; // 스테이킹 상태

    for (let i = 0; i < aPayload.length; i++) {
      arrFactoryPoolDetails.push(() => web3authCall?.getStakingCall().getFactoryPoolDetails(String(i)));
      arrState.push(() => web3authCall?.getStakingCall().state(aPayload[i]));
    }
    const arrFactoryDetails: ResGetPoolDetailsCall[] = await promiseAllSettled(arrFactoryPoolDetails);
    const state = await promiseAllSettled(arrState);
    const mergedArray = arrFactoryDetails
      .map((item: any, index) => ({
        ...item,
        status: StateFilter(state[index]),
        statusIndex: state[index],
        contractAddr: aPayload[index],
      }))
      .reduce((acc, item) => {
        let key = reducePoolStatus(item.statusIndex);
        return reduceCheckAndPushKey(acc, key, item);
      }, {});

    setLists(mergedArray);
  };
  return (
    <>
      {/* Open Pools */}
      <Box
        sx={{
          padding: { xs: '16px 24px', md: '20px 24px' },
          maxWidth: '1680px',
        }}
      >
        <Box>
          <Typography color={theme.greyscale.darkgrey2} variant={'h2'}>
            Open Pools
          </Typography>
        </Box>
        <Box
          sx={{
            paddingTop: '16px',
            display: 'flex',
            flexDirection: 'column',
            gap: {
              xs: '16px',
              md: '10px',
            },
          }}
        >
          {lists?.open &&
            lists.open.map((item: ResGetPoolDetailsCall, index: number) => (
              <Fragment key={index}>
                <PoolsCard item={item} type="open" />
              </Fragment>
            ))}
        </Box>
      </Box>
      {/* Closed Pools */}
      <Box
        sx={{
          padding: { xs: '16px 24px', md: '20px 24px' },
          maxWidth: '1680px',
        }}
      >
        <Box>
          <Typography color={theme.greyscale.darkgrey2} variant={'h2'}>
            Closed Pools
          </Typography>
        </Box>
        <Box
          sx={{
            paddingTop: '16px',
            display: 'flex',
            flexDirection: 'column',
            gap: {
              xs: '16px',
              md: '10px',
            },
          }}
        >
          {lists?.closed &&
            lists.closed.map((item: ResGetPoolDetailsCall, index: number) => (
              <Fragment key={index}>
                <PoolsCard item={item} type="closed" />
              </Fragment>
            ))}

          {/* PC - View Archived Pools */}
          <Typography
            sx={{
              display: {
                xs: 'none',
                md: 'block',
              },
              cursor: 'pointer',
            }}
            variant="body3"
            color={theme.greyscale.grey2}
          >
            {'View Archived Pools >'}
          </Typography>

          {/* Mobile - View Archived Pools */}
          <CommonButton
            sx={{
              display: {
                xs: 'block',
                md: 'none',
              },
              borderRadius: '10px',
              height: '48px',
              marginBottom: '55px',
            }}
            color={'#ffffff'}
            bgColor={theme.brand.primary}
            text={'View Archived Pools'}
            handleClick={() => {}}
            variant={'subtitle1'}
          />
        </Box>
      </Box>
    </>
  );
}
